"use client";
import { defaultLocale } from "@/config";
import { Tabs } from "antd";
import { StyledArticle } from "../Blogs/BlogArticle";
import { useTranslations } from "next-intl";
import { useState } from "react";
const ProductDescription = ({ product, locale }) => {
	const t = useTranslations();
	const [activeKey, setActiveKey] = useState<string>("1");

	return (
		<div className="pdes">
			<Tabs
				type="card"
				className=" !font-abeezee"
				onChange={(key) => setActiveKey(key)}
				defaultActiveKey={activeKey || "1"}
				items={[
					{
						label: (
							<div
								className={`font-body ${
									activeKey == "1" ? "bg-[#253333] text-white" : "bg-white text-black"
								} flex h-10 items-center justify-center gap-2.5 rounded-full px-3.5 text-sm font-medium`}
							>
								<span className="flex h-7 w-7 items-center justify-center rounded-full bg-white">
									<img src="/image/miaoshu.svg" className="h-4 w-4" alt="description" />
								</span>
								<p className="">{t("product.description")}</p>
							</div>
						),
						key: "1",
						children: (
							<StyledArticle>
								<div
									className="p-3 md:p-4"
									dangerouslySetInnerHTML={{
										__html:
											locale == defaultLocale
												? filterSortDsc(product.descriptionJson).longDsc
												: filterSortDsc(product.translation.descriptionJson).longDsc ||
													filterSortDsc(product.descriptionJson).longDsc,
									}}
								/>
							</StyledArticle>
						),
					},
					{
						label: (
							<div
								className={`font-body ${
									activeKey == "2" ? "bg-[#253333] text-white" : "bg-white text-black"
								} flex h-10 items-center justify-center gap-2.5 rounded-full px-3.5 text-sm font-medium`}
							>
								<span className="flex h-7 w-7 items-center justify-center rounded-full bg-white">
									<img src="/image/shipping.svg" className="h-4 w-4" alt="description" />
								</span>
								<p className="">{t("common.shippingInfo")}</p>
							</div>
						),
						key: "2",
						children: (
							<StyledArticle>
								<div className="p-3 !font-body text-sm leading-relaxed md:p-4">
									<h2>{t("common.Shipping")}</h2>
									<p>{t("common.s1")}</p>
									<p>{t("common.s2")}</p>
									<p>{t("common.s3")}</p>
								</div>
							</StyledArticle>
						),
					},
				]}
			/>
			<style
				dangerouslySetInnerHTML={{
					__html: `
					.product_desc .ant-tabs-tab-btn {
						color: #000 !important;
					}
		`,
				}}
			></style>
		</div>
	);
};

export default ProductDescription;

type dscList = {
	blocks: dscObj[];
};
type dscObj = {
	data: { text: string };
	type: string;
};
const filterSortDsc = (dsc: string) => {
	const dscObj = JSON.parse(dsc) as dscList;
	let sortDsc = "";
	let longDsc = "";
	if (dscObj && dscObj.blocks.length > 0) {
		sortDsc = dscObj.blocks[1].data.text;
		longDsc = handlerInnerHtml(dscObj.blocks[0].data.text);
	}
	return { sortDsc, longDsc };
};

const handlerInnerHtml = (html: string): string => {
	if (!html) return html;
	return html
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&")
		.replace(/&quot;/g, '"')
		.replace(/&#8216;/g, "‘")
		.replace(/&#8217;/g, "’")
		.replace(/&#8211;/g, "–")
		.replace(/&nbsp;/g, " ");
};
